import { render, staticRenderFns } from "./MagChart.vue?vue&type=template&id=f3c48b40&"
import script from "./MagChart.vue?vue&type=script&lang=js&"
export * from "./MagChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports